import styled from 'styled-components';
import { rem } from 'polished';
import customMedia from '../../../config/themes/variables/breakpoints';

const StyledInput = styled.input`
  border: 1px solid ${props => props.theme.colors.main};
  caret-color: ${props => props.theme.colors.primary};
  line-height: 0;
  padding: ${rem('8.5px')} ${rem('32px')} ${rem('8.5px')} ${rem('10px')};
  width: 100%;
  &:focus {
    box-shadow: 1px 1px 1px ${props => props.theme.colors.main} inset,
      -1px -1px 1px ${props => props.theme.colors.main} inset;
  }
  ${customMedia.lessThan('1023px')`
    position: relative;
    margin-right: ${rem('16px')};
    width: calc(100% - ${rem('68px')});
  `};
`;

const StyleBoxIcon = styled.button`
  align-items: center;
  background-color: ${props => props.theme.colors.main};
  border: none;
  display: inline-flex;
  /* height: 100%; */
  justify-content: center;
  padding: 0;
  width: ${rem('68px')};
  & > svg {
    margin: auto;
  }
  ${customMedia.lessThan('1023px')`
    width: auto;
    margin: auto;
    &:hover,
    &:active {
      background-color: inherit;
    }
  `};
`;

const InputBox = styled.div`
  display: flex;

  ${customMedia.lessThan('1023px')`
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 0;
    width: 100%;
    margin-bottom: 0;
    height: ${rem('50px')};
    background: ${props => props.theme.colors.main};
    padding-top: ${rem('7px')};
    padding-bottom: ${rem('7px')};
    ${StyledInput} {
      left: 16px;
    }
    ${StyleBoxIcon} {
      position: absolute;
      left: ${props => (props.expanded ? `80%` : `50%`)};
      top: 50%;
      transform: translate(-50%, -50%);
      transition: transform 1s;
   
      > svg {
        z-index: 1;
      }
      &:after {
        content: '';
        width: ${rem('1024px')};
        height: ${rem('50px')};
        margin-top: ${rem('2px')};
        background: ${props => props.theme.colors.main};
        position: absolute;
        transition: transform 0.5s;
      }
      ${props =>
        props.expanded &&
        `
          transform: translate(110%, -50%);
          &:after {
            transform: translate(48%, 0%);
          }
        `};
    }
  `};
`;

export { StyledInput, InputBox, StyleBoxIcon };
